import { PopularVideo } from './cms-video.interface';

export interface PopularVideoItem {
  popularVideo: PopularVideo;
}
